import React from 'react';

import { Stack, Text, ToggleGroup, ToggleGroupItem } from '@eluve/components';

export interface RatingSelectorProps {
  labelFor0?: string;
  labelFor5?: string;
  labelFor10?: string;
  onRatingSelected: (rating: number | null) => void;
}

export const RatingSelector: React.FC<RatingSelectorProps> = ({
  labelFor0,
  labelFor5,
  labelFor10,
  onRatingSelected,
}) => {
  return (
    <Stack gap={1} align="stretch">
      <ToggleGroup
        fullWidth
        type="single"
        variant="outline"
        className="items-start gap-0"
        onValueChange={(value) => {
          if (value.length) {
            onRatingSelected(Number(value));
          } else {
            onRatingSelected(null);
          }
        }}
      >
        {Array.from(Array(11).keys()).map((num) => (
          <ToggleGroupItem
            key={num}
            value={`${num}`}
            aria-label={`Select ${num}`}
            className={'px-1 sm:px-3'}
          >
            {num}
          </ToggleGroupItem>
        ))}
      </ToggleGroup>

      <Stack direction="horizontal" justify="between" align="stretch">
        <Text className="w-full">{labelFor0}</Text>
        <Text className="w-full text-center">{labelFor5}</Text>
        <Text className="w-full text-end">{labelFor10}</Text>
      </Stack>
    </Stack>
  );
};
